<img
  class="certificate-overview"
  alt="Zaświadczenie"
  [src]="'/rest/crm/idd-training-certificate/' + iddTrainingCertificateId + '/image'"
/>
